'use strict';

var cov_xnby3dnj4 = function () {
  var path = 'D:\\freelance\\phongthuy-vina\\phongthuy_frontend\\src\\app\\ads\\ads.js',
      hash = '3ce0211ca34cf2f53fc902db42309c0ddb962852',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: 'D:\\freelance\\phongthuy-vina\\phongthuy_frontend\\src\\app\\ads\\ads.js',
    statementMap: {
      '0': {
        start: {
          line: 3,
          column: 4
        },
        end: {
          line: 3,
          column: 30
        }
      },
      '1': {
        start: {
          line: 4,
          column: 20
        },
        end: {
          line: 8,
          column: 5
        }
      },
      '2': {
        start: {
          line: 9,
          column: 4
        },
        end: {
          line: 16,
          column: 7
        }
      },
      '3': {
        start: {
          line: 15,
          column: 6
        },
        end: {
          line: 15,
          column: 48
        }
      },
      '4': {
        start: {
          line: 21,
          column: 0
        },
        end: {
          line: 26,
          column: 5
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 3
          }
        },
        loc: {
          start: {
            line: 2,
            column: 110
          },
          end: {
            line: 18,
            column: 3
          }
        },
        line: 2
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 14,
            column: 12
          },
          end: {
            line: 14,
            column: 13
          }
        },
        loc: {
          start: {
            line: 14,
            column: 20
          },
          end: {
            line: 16,
            column: 5
          }
        },
        line: 14
      }
    },
    branchMap: {},
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0
    },
    f: {
      '0': 0,
      '1': 0
    },
    b: {},
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AdsController = function AdsController($scope, $httpParamSerializerJQLike, $http, $rootScope, $stateParams, $window, myVars, $location) {
  _classCallCheck(this, AdsController);

  ++cov_xnby3dnj4.f[0];
  ++cov_xnby3dnj4.s[0];

  $scope.checkinfo = myVars;
  var dataObj = (++cov_xnby3dnj4.s[1], {
    mm: $stateParams.mm,
    cp: $stateParams.cpid,
    packageid: $stateParams.packageid
  });
  ++cov_xnby3dnj4.s[2];
  $http({
    method: 'POST',
    url: $rootScope.apiOpen,
    data: $httpParamSerializerJQLike(dataObj),
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  }).then(function (data) {
    ++cov_xnby3dnj4.f[1];
    ++cov_xnby3dnj4.s[3];

    $window.location.href = data.data.message;
  });
  // $window.location.href = 'http://phongthuy19.vn';
};

++cov_xnby3dnj4.s[4];


angular.module('app').component('ads', {
  templateUrl: 'app/ads/ads.html',
  controller: AdsController
});